import React, { useEffect, useState, useRef } from "react";
import googleImg from "../static/img/google.png";
import UserService from "../../../class/User/UserService";
import UserServices from "../../../class/User_copy/UserService";

import AuthService from "../../../class/services/AuthService";

import ModalForgot from "./modal_forgot";

import { useTranslation } from "react-i18next";

function ModalLogin({
    show,
    onClose,
    setIsLogged,
    setUserId,
    onOpenRegisterModal,
    setIsUserCashBlocked,
    setHomeReload,
    triggerLinkLogin,
    setTriggerLinkLogin,
}) {
    const { t } = useTranslation();
    const modalRef = useRef();
    const [animate, setAnimate] = useState(false);
    const [visible, setVisible] = useState(show);
    const [email, setEmail] = useState(""); // Стан для зберігання email
    const [password, setPassword] = useState(""); // Стан для зберігання пароля
    const [error, setError] = useState(""); // Стан для зберігання повідомлень про помилки
    const [showPassword, setShowPassword] = useState(false); // Стан для показу/приховування пароля
    const [block, setBlock] = useState("block");

    const handleOpenModal = () => {
        modalRef.current.open();
        setBlock("none");
    };

    useEffect(() => {
        if (show) {
            setVisible(true);
            setTimeout(() => setAnimate(true), 200);
        } else {
            setAnimate(false);
            setTimeout(() => setVisible(false), 300);
        }
    }, [show]);

    useEffect(() => {
        if (triggerLinkLogin) {
            handleLinkLoginLogin();
        }
    }, [triggerLinkLogin]);

    if (!visible) return null;

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const response = await UserServices.login(email, password);
            // console.log("Login successful:", response);
            // if (response.status) {
            //   // ⬇️ 1. Если сервер прислал redirect_url — сразу уходим по нему
            //   if (response.redirect_url) {
            //     // Для React Router 6 можно сделать navigate(response.redirect_url);
            //     // но самый универсальный способ — через window.location:
            //     window.location.href = response.redirect_url;
            //     return; // прерываем дальнейшее выполнение
            //   }
            // }
            // ⬇️ 2. Если сервер прислал user_auth_token — сохраняем его
            if (response.status == "ok") {
                const user = response.params.user;

                if (user.cashblocked && user.cashblocked == 1) {
                    AuthService.setCustom("user_cash_block", true);

                    // setIsUserCashBlocked(true);
                }
                AuthService.setToken(user.user_auth_token);
                AuthService.setCustom("username", user.username);
                AuthService.setCustom("user_id", user.user_auth_token);
                AuthService.setCustom("skin_token", user.id); //skin_token
                AuthService.setCustom("skin_order", user.skin_id); //skin_order
                AuthService.setCustom("currency", user.currency);

                setIsLogged(true);
                setHomeReload(true);
                onClose();
            } else {
                setError(response.message || t("Login_failed"));
            }
        } catch (error) {
            setError(t("An_error_occurred._Please_try_again."));
            console.error(error);
        }
    };

    const handleLinkLoginLogin = async () => {
        // ← rimosso (e)
        setError("");

        try {
            const response = await UserServices.linkLogin(
                AuthService.getCustom("user_hash"),
            );
            if (response.status == "ok") {
                const user = response.params.user;
                // console.log(response);
                if (user.cashblocked && user.cashblocked == 1) {
                    AuthService.setCustom("user_cash_block", true);
                }

                AuthService.setToken(user.user_auth_token);
                AuthService.setCustom("username", user.username);
                AuthService.setCustom("user_id", user.user_auth_token);
                AuthService.setCustom("skin_token", user.id); //skin_token
                AuthService.setCustom("skin_order", user.skin_id); //skin_order
                AuthService.setCustom("currency", user.currency);

                setIsLogged(true);
                setHomeReload(true);
                onClose();
            } else {
                setError(response.message || t("Login_failed"));
            }
        } catch (error) {
            setError(t("An_error_occurred._Please_try_again."));
            console.error(error);
        }
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword); // Змінюємо стан для показу/приховування пароля
    };

    return (
        <>
            <div
                className={`modal fade login_modal ${animate ? "show" : ""}`}
                id="login_modal"
                tabIndex="-1"
                style={{ display: block }}
                aria-modal={show ? "true" : "false"}
                role="dialog"
            >
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>{t("Login")}</h3>
                            <button
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={onClose}
                            ></button>
                        </div>
                        <div className="modal-body">
                            {error && (
                                <div className="alert alert-danger">
                                    {error}
                                </div>
                            )}{" "}
                            {/* Показуємо помилки */}
                            <section className="forms">
                                <div className="form login">
                                    <div className="form-content">
                                        <form onSubmit={handleLogin}>
                                            <div className="field input-field">
                                                <input
                                                    type="text"
                                                    placeholder={t("Username")}
                                                    className="input"
                                                    value={email}
                                                    onChange={(e) =>
                                                        setEmail(e.target.value)
                                                    } // Оновлюємо email
                                                    required // Вимога для заповнення
                                                />
                                            </div>
                                            <div className="field input-field">
                                                <input
                                                    type={
                                                        showPassword
                                                            ? "text"
                                                            : "password"
                                                    } // Змінюємо тип поля пароля
                                                    placeholder={t("Password")}
                                                    className="password"
                                                    value={password}
                                                    onChange={(e) =>
                                                        setPassword(
                                                            e.target.value,
                                                        )
                                                    } // Оновлюємо пароль
                                                    required // Вимога для заповнення
                                                />
                                                <i
                                                    className={`bx ${showPassword ? "bx-show" : "bx-hide"} eye-icon`}
                                                    onClick={
                                                        togglePasswordVisibility
                                                    }
                                                ></i>
                                            </div>
                                            {/* <div class="form-link">
                              <a onClick={handleOpenModal} class="forgot-pass">Forgot password?</a>
                          </div> */}
                                            <div className="field button-field">
                                                <button type="submit">
                                                    {t("Login")}
                                                </button>{" "}
                                                {/* Змінили на submit */}
                                            </div>
                                        </form>
                                        {/* <div className="form-link">
                      <span>
                        {t('Don_t_have_an_account')}{' '}
                        <a
                          href="#"
                          className="link signup-link"
                          onClick={(e) => {
                            e.preventDefault();   
                            onClose();             
                            setTimeout(onOpenRegisterModal, 300); 
                          }}
                        >
                          {t('Sign_up')}
                        </a>
                      </span>
                    </div> */}
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>

            <ModalForgot ref={modalRef} setBlock={setBlock} />

            {visible && (
                <div
                    className={`modal-backdrop fade ${animate ? "show" : ""}`}
                    onClick={onClose}
                ></div>
            )}
        </>
    );
}

export default ModalLogin;
